export default {
      id: "money-document-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#money-document",
      toString: function () {
        return this.url;
      }
    }